export const getTaskDaysRemaining = (dueAt: string | null) => {
  if (!dueAt) return null;

  const parsedDate = new Date(dueAt);
  if (Number.isNaN(parsedDate.getTime())) return null;

  const dueDate = new Date(
    parsedDate.getFullYear(),
    parsedDate.getMonth(),
    parsedDate.getDate(),
  );
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

  return Math.round((dueDate.getTime() - today.getTime()) / 86_400_000);
};
